import { useUserSettings } from '@/modules/settings/hooks/useUserSettings'
import type { UseAssetFormLayout } from '../types'
import { tween } from '@/utils/animation/tween'
import { ref } from 'vue'
import { Display } from '../components/display'
import Bubbletip from 'components/bubbletip'
import { prettyNumber } from '@/utils/number/format'
import { useForexTickers } from '@/integrations/findex/hooks/forex/useForexTickers'
import { EAssetType } from 'findef'

export const currentTotalValueLayout = (): UseAssetFormLayout => ({
  needs: ['invested.type', 'asset.type', 'asset.ledger.sharePrice.type'],
  component: (state) => {
    const settings = useUserSettings()
    const val = ref<number>(0)
    const w = tween(val, { duration: 0.5 });
    const tickerFrom = state?.asset.ledger.sharePrice.type || settings.currency.value

    const forex = useForexTickers();
    const ticker = forex.getTickerRef(tickerFrom, settings.currency.value);

    const elRef = ref()
    return (props) => {
      const state = props.state.value
      const shares = state?.quantity || 0
      const text = `Converted from ${(state?.asset.ledger.sharePrice.value || 0) * shares} ${tickerFrom}`

      if (state.asset.type === EAssetType.CASH) {
        val.value = props.data.value.currentValue * ticker.value.bid;
      } else {
        val.value = props.data.value.currentValue
      }

      const formatted = prettyNumber(w.value, {
        american: true
      })

      return (
        <>
          <Display
            ref={elRef}
            title={'My Current Value'}
            value={`${formatted} ${settings.currency.value}`}
          />
          <Bubbletip
            variant="white"
            size="s"
            disabled={tickerFrom === settings.currency.value}
            triggerRef={elRef}
            text={text}
            style={{ position: 'absolute' }}
          />
        </>
      )
    }
  }
})
